import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { AdminInvoiceProfile, Reservation } from 'rest-client';

@Component({
  selector: 'bkg-summary-reservation',
  templateUrl: './summary-reservation.component.html',
})
export class SummaryReservationComponent implements OnChanges {
  @Input() reservation: Reservation;

  profile: AdminInvoiceProfile[];

  ngOnChanges(changes: SimpleChanges): void {
    this.reservation = changes.reservation.currentValue as Reservation;
    if (this.reservation?.id_invoice_profile) {
      this.profile = this.reservation?.client?.invoice_profiles?.filter(
        (profile: AdminInvoiceProfile) =>
          this.reservation.id_invoice_profile === Number(profile.id)
      );
    }
  }
}
